







































































































import PartnerReportVehicleSuggestionMixin from "@/components/partner/report/v2/vehicle/PartnerReportVehicleSuggestionMixin.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { VehicleTabs } from "@/lib/enum/vehicle-tabs.enum";
import { VehicleStateEnum } from "@/lib/enum/vehicleState.enum";
import { requiredRule } from "@/lib/rules/requiredRule";
import { GoToHelper } from "@/lib/utility/goToHelper";
import { handleError } from "@/lib/utility/handleError";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Registration } from "@/models/registration.entity";
import { VehicleRegistration } from "@/models/vehicle-registration.entity";
import { IVehicle } from "@/models/vehicle.entity";
import { IReport } from "@/models/report.entity";
import {
  MrfiktivCreateVehicleDtoGen,
  MrfiktivCreateVehicleRegistrationDtoGen,
  MrfiktivUpdateReportDtoGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { PartnerModule } from "@/store/modules/partner";
import { VehicleModule } from "@/store/modules/vehicle.store";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref } from "vue-property-decorator";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import RefsVehicle from "../utility/RefsVehicle.vue";
import VehicleApiSelection from "../utility/VehicleApiSelection.vue";

@Component({
  components: { RefsVehicle, ConfirmActionDialog, VehicleApiSelection, LatestEntriesCardEmpty }
})
export default class VehicleTimeLineElement extends mixins(
  DarkModeHighlightMixin,
  PermissionMixin,
  PartnerReportVehicleSuggestionMixin
) {
  @Prop()
  report!: IReport;

  loadingVehicle = false;

  loadingUpdate = false;

  vehicle: IVehicle | null = null;

  selectedVehicle: IVehicle | null = null;

  isUpdateVehicleDialog = false;

  isSelectionMade = false;

  vehicleSuggestions: IVehicle[] = [];

  isLoadingVehicleIdUpdate = false;

  selected: IVehicle | null = null;

  @Ref("vehicle-api-selection")
  selection!: VehicleApiSelection;

  get requiredRule() {
    return [requiredRule()];
  }

  async mounted() {
    await this.getVehicle();
  }

  async lookupSuggestions() {
    if (!this.canReadVehicle) {
      return;
    }

    this.lookupVehicleSuggestions(this.report);
  }

  async getVehicle() {
    const vehicleId = this.report.vehicleId;
    if (!vehicleId) return;

    this.loadingVehicle = true;

    try {
      this.vehicle = await VehicleModule.getOne({ partnerId: this.report.partnerId, vehicleId: vehicleId });

      this.$nextTick(() => {
        if (this.vehicle && this.selection) {
          this.selection.selected = this.vehicle?.id ?? null;
          if (!this.selection.items?.find(i => i.id === this.vehicle?.id)) {
            this.selection.items?.push(this.vehicle);
          }
        }
      });
    } catch (error) {
      this.$log.error(error);
    } finally {
      this.loadingVehicle = false;
    }
  }

  changeVehicleReference() {
    this.isUpdateVehicleDialog = true;
    this.isSelectionMade = false;

    this.lookupSuggestions();

    // Preselect current vehicle
    this.getVehicle();
  }

  async openVehicleDetail(vehicle: IVehicle) {
    if (!vehicle) return;

    await new GoToHelper(this.$router).goToVehicleDetail(vehicle.id, vehicle.partnerId, VehicleTabs.HOME);
  }

  async createNewVehicle() {
    const partnerId = this.report.partnerId;
    const data: MrfiktivCreateVehicleDtoGen = {
      identificationnumber: this.report.registrationResults.identificationnumber,
      displayName: this.report.numberplate,
      state: VehicleStateEnum.INACTIVE,
      mileages: [],
      numberplate: this.report.numberplate,
      registration: new VehicleRegistration(this.report.registrationResults) as MrfiktivCreateVehicleRegistrationDtoGen
    };

    try {
      this.isLoadingVehicleIdUpdate = true;

      const vehicle = await VehicleModule.create({ partnerId, data });

      await this.select(vehicle);

      this.isUpdateVehicleDialog = false;
      this.report.vehicleId = vehicle.id;
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoadingVehicleIdUpdate = false;
    }
  }

  select(selected?: IVehicle) {
    this.selected = selected ?? null;
    this.isSelectionMade = true;
  }

  async confirm() {
    try {
      const selected = this.selected;

      this.isLoadingVehicleIdUpdate = true;

      const registrationDto = new Registration({
        ...selected?.registration,
        numberplate: selected?.numberplate ?? selected?.registration?.numberplate,
        identificationnumber: selected?.identificationnumber ?? selected?.registration?.identificationnumber
      });

      const updateReportDto = {
        numberplate: selected?.numberplate,
        vehicleId: selected?.id || null,
        registrationResults: registrationDto
      } as MrfiktivUpdateReportDtoGen;

      const updated = await PartnerModule.report.updatePartial(updateReportDto);

      this.isUpdateVehicleDialog = false;
      this.report = updated;
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoadingVehicleIdUpdate = false;
    }
  }
}
